<script setup lang="ts">
import { InfoIcon } from "lucide-vue-next"
</script>

<template>
  <div class="rounded-md border border-[#e78ac7] bg-[#e78ac7]/3 p-4.5">
    <div class="flex gap-4">
      <InfoIcon class="mt-0.5 size-6 shrink-0 text-[#f157bb]" />
      <div>
        <p>
          El plan de compensación flexible te permite destinar una parte de tu
          salario a productos o servicios adaptando tu paquete retributivo a tu
          situación personal y optimizando tu compensación total.
        </p>

        <p class="mt-2 font-bold">¿Cómo funciona?</p>

        <p>
          1) Selecciona los beneficios que quieres activar<br />
          2) El importe se descuenta de tu salario bruto mensual<br />
          3) Accede a ventajas fiscales según la normativa vigente<br />
          4) Modifica tu selección cuando lo necesites
        </p>

        <p class="mt-2 font-bold">¿Qué puedes incluir?</p>

        <div
          class="border-border mt-2 w-full overflow-x-auto rounded-md border"
        >
          <table class="w-full text-sm">
            <thead>
              <tr class="border-border border-b">
                <th class="px-4 py-2 text-left font-semibold">Beneficio</th>
                <th class="px-4 py-2 text-left font-semibold">Información</th>
              </tr>
            </thead>
            <tbody>
              <tr class="border-border border-b">
                <td class="px-4 py-2 align-top font-medium">
                  Amplía tu seguro médico con la tarifa reembolso
                </td>
                <td class="text-muted-foreground px-4 py-2 align-top">
                  Accede a atención sanitaria privada con la flexibilidad de
                  elegir profesional con cobertura de reembolso de los gastos.
                </td>
              </tr>
              <tr class="border-border border-b">
                <td class="px-4 py-2 align-top font-medium">
                  Seguro médico para familiares (hijos y/o cónyuge)
                </td>
                <td class="text-muted-foreground px-4 py-2 align-top">
                  Incluye a los tuyos en tu seguro médico y amplía la cobertura
                  a tu familia a través de tu plan de compensación flexible.
                  Importe exento de IRPF hasta 500€ anuales por familiar.
                </td>
              </tr>
              <tr class="border-border border-b">
                <td class="px-4 py-2 align-top font-medium">
                  Seguro médico para familiares (hijos y/o cónyuge) con
                  ampliación de tarifa reembolso
                </td>
                <td class="text-muted-foreground px-4 py-2 align-top">
                  Incluye a los tuyos en tu seguro médico, con opción de elegir
                  profesional con cobertura de reembolso en los gastos. Importe
                  exento de IRPF hasta 500€ anuales por familiar.
                </td>
              </tr>
              <tr class="border-border border-b">
                <td class="px-4 py-2 align-top font-medium">
                  Pago de guardería
                </td>
                <td class="text-muted-foreground px-4 py-2 align-top">
                  Gestiona el pago de la guardería a través de tu compensación
                  flexible con Edenred, de forma sencilla y con ventajas
                  fiscales. El importe está 100% exento de IRPF, lo que te
                  permite optimizar tu salario (no incluye matrícula o pago de
                  comedor).
                </td>
              </tr>
              <tr>
                <td class="px-4 py-2 align-top font-medium">
                  Transporte público
                </td>
                <td class="text-muted-foreground px-4 py-2 align-top">
                  Gestiona tus gastos de transporte público a través de una
                  tarjeta prepago de forma cómoda. Exento de IRPF hasta 1.500€.
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
